import { SseEvent, SseMessage } from "./sse.types";

/**
 * Parses an SSE `data` payload as JSON.
 *
 * Returns null rather than throwing when the payload is not JSON, so a
 * plain-text stream never breaks a consumer expecting objects.
 *
 * Free of Angular and DOM dependencies so it can be unit tested directly.
 */
export function parseSseData<T>(raw: string): T | null {
    const trimmed = (raw || "").trim();
    if (!trimmed) {
        return null;
    }
    try {
        return JSON.parse(trimmed) as T;
    } catch {
        return null;
    }
}

/** Lifts a raw wire message into a JSON-parsed event. */
export function toSseEvent<T>(message: SseMessage): SseEvent<T> {
    return {
        event: message.event,
        id: message.id,
        data: parseSseData<T>(message.data),
        raw: message.data,
    };
}
